import * as tslib_1 from "tslib";
import { Base } from "../base-component";
import "./form-item-business-cards.component.scss";
import * as $ from "jquery";
import "bootstrap-datepicker";
var FormItemBusinessCreditGarageCards = /** @class */ (function (_super) {
    tslib_1.__extends(FormItemBusinessCreditGarageCards, _super);
    function FormItemBusinessCreditGarageCards(element, analyticsService) {
        var _this = _super.call(this, element) || this;
        _this.count = 1;
        _this.dataChecks = true;
        _this.map = new Map();
        _this.iSstep1Completed = false;
        _this.iSstep2Completed = false;
        _this.iSstep3Completed = false;
        _this.errors = [];
        _this.emptyerrors = [];
        return _this;
    }
    FormItemBusinessCreditGarageCards.prototype.init = function () {
        this.form = this.element.querySelector("form");
        this.businessAccountHeld = this.element.querySelector("select[name=business-account-held-with]");
        this.loanPurpose = this.element.querySelector(".js-loan-purpose");
        this.loanAmount = this.element.querySelector(".js-loan-amount");
        this.wizardContainer = this.element.querySelector(".form-container-wizard__wizard");
        this.wizardStepsContainer = this.element.querySelector(".form-container-wizard__steps");
        this.bulletContainer = this.element.querySelector(".form-container-wizard__bullets-container");
        this.customHeading = this.element.querySelector(".customHeading");
        this.stepNo = this.element.querySelector(".form-container-wizard__stepno");
        this.isSBCustomer = this.element.querySelector(".js-sb-customer-radio-group");
        this.modifiersRadiosToggle = Array.from(this.element.querySelectorAll(".js-sb-customer-radio-group"));
        this.entityType = this.element.querySelector("select[name=entity-type]");
        this.marriageStatusSelect = this.element.querySelector("select[name=marital-status]");
        this.marriageStatus = this.element.querySelector(".marriage-status");
        this.marriageType = this.element.querySelector(".marriage-type");
        if (this.marriageType) {
            this.marriageTypeInputs = Array.from(this.marriageType.querySelectorAll("input[type=radio]"));
        }
        this.marriageConsent = this.element.querySelector(".marriage-consent");
        this.businessName = this.element.querySelector(".business-name");
        this.businessReg = this.element.querySelector(".business-registration");
        this.saId = this.element.querySelector("input[name=sa-id]");
        this.sourceOfFunds = this.element.querySelector("select[name=source-of-funds]");
        if (this.form) {
            this.displayLoader = this.form.querySelector(".form__loader--container");
            this.displayFields = this.element.querySelector(".form-container__fields");
            //this.displaySuccess = this.form.querySelector(`.form-container__success`);
            //this.displayError = this.form.querySelector(".form-container__error");
            //this.displayDecline = this.form.querySelector(".form-container__declined");
            this.formFields = this.element.querySelector(".form__fields--container");
            this.formThankyou = this.element.querySelector(".form__thankyou--container");
            this.customHeading = this.element.querySelector(".customHeading");
        }
        // buttons
        this.closeButton = this.element.querySelector(".js-apply-now-modal-close");
        this.backButton = Array.from(this.element.querySelectorAll(".js_prev-step-button"));
        this.step1Button = this.element.querySelector(".js_next-step1-button");
        this.step2Button = this.element.querySelector(".js_next-step2-button");
        this.showStep(1);
        this.buttonSubmit = this.element.querySelector(".js_submit-button");
        this.doneSubmit = this.element.querySelector(".js_done-button");
        this.showMoreBtn = this.element.querySelector(".data-privacy-collapse-show");
        this.showLessBtn = this.element.querySelector(".data-privacy-collapse-hide");
        this.dataPrivacyDetailArea = this.element.querySelector(".data-privacy-detail");
        this.dataSharingGroupHideBtn = this.element.querySelector(".data-sharing-group-hide-btn");
        this.dataSharingGroupShowBtn = this.element.querySelector(".data-sharing-group-show-btn");
        this.dataSharingGroupTextArea = this.element.querySelector(".data-sharing-group");
        this.dataSharing3rdPartyShowBtn = this.element.querySelector(".data-sharing-3rd-party-show-btn");
        this.dataSharing3rdPartyHideBtn = this.element.querySelector(".data-sharing-3rd-party-hide-btn");
        this.dataSharing3rdPartyTextArea = this.element.querySelector(".data-sharing-3rd-party");
        this.dataSharingBoardersHideBtn = this.element.querySelector(".data-sharing-boarders-hide-btn");
        this.dataSharingBoardersShowBtn = this.element.querySelector(".data-sharing-boarders-show-btn");
        this.dataSharingBoardersTextArea = this.element.querySelector(".data-sharing-boarders");
        this.dataSharingTeleSaleHideBtn = this.element.querySelector(".data-sharing-telesale-hide-btn");
        this.dataSharingTeleSaleShowBtn = this.element.querySelector(".data-sharing-telesale-show-btn");
        this.dataSharingTeleSaleTextArea = this.element.querySelector(".data-sharing-telesale");
        this.dataSharingSmsShowBtn = this.element.querySelector(".data-sharing-email-show-btn");
        this.dataSharingSmsHideBtn = this.element.querySelector(".data-sharing-email-hide-btn");
        this.dataSharingSmsTextArea = this.element.querySelector(".data-sharing-email");
        this.dataSharingEmailHideBtn = this.element.querySelector(".data-sharing-sms-hide-btn");
        this.dataSharingEmailShowBtn = this.element.querySelector(".data-sharing-sms-show-btn");
        this.dataSharingEmailTextArea = this.element.querySelector(".data-sharing-sms");
        //Analytics
        this.form.setAttribute("data-frmcontainer", "business credit card form | personal details");
        this.analyticsService.startDtmApplication("application: products and services | bank-with-us | company-cards", "business credit card form");
        this.updatePageName("step 1 personal details form");
        this.toggleModifiers(null, ".js-sb-customer-acc-no");
        this.updateForms();
    };
    FormItemBusinessCreditGarageCards.prototype.addErrorMessage = function (pElement, pMessages) {
        var _parent = pElement.closest(".form__group");
        if (_parent) {
            var _errorDiv = _parent.querySelector(".form__group--error_message");
            if (_errorDiv) {
                _errorDiv.remove();
            }
            if (pMessages.length > 0) {
                _errorDiv = document.createElement("div");
                _errorDiv.classList.add("form__group--error_message");
                var _errors_1 = document.createElement("ul");
                pMessages.forEach(function (pMessage) {
                    var _error = document.createElement("li");
                    _error.innerHTML = pMessage;
                    _errors_1.appendChild(_error);
                });
                _errorDiv.appendChild(_errors_1);
                if (_parent) {
                    _parent.appendChild(_errorDiv);
                }
            }
        }
    };
    FormItemBusinessCreditGarageCards.prototype.bindEvents = function () {
        var _this = this;
        if (this.form) {
            var _formFields = Array.from(this.form.querySelectorAll("input, select"));
            if (_formFields) {
                _formFields.forEach(function (pEement) {
                    pEement.addEventListener("blur", function (pEvent) {
                        _this.validationService.validateBlur(pEvent.currentTarget);
                    });
                });
            }
        }
        if (this.entityType) {
            this.entityType.addEventListener("change", function (pEvent) {
                _this.updateForms(pEvent, "entity");
            });
        }
        if (this.marriageStatus) {
            this.marriageStatus.addEventListener("change", function (pEvent) {
                _this.updateForms(pEvent, "status");
            });
        }
        if (this.marriageTypeInputs) {
            this.marriageTypeInputs.map(function (item) { return item.addEventListener("click", function (pEvent) {
                _this.updateForms(pEvent, "type");
            }); });
        }
        if (this.modifiersRadiosToggle) {
            this.modifiersRadiosToggle.map(function (item) { return item.addEventListener("click", function (event) {
                _this.toggleModifiers(event, ".js-sb-customer-acc-no");
            }); });
        }
        //Step 1 Next Button
        if (this.step1Button) {
            this.step1Button.addEventListener("click", function (pEvent) {
                var _form = _this.form.querySelector(".step1");
                var _formFields = _form.querySelectorAll("input, select");
                _this.validationService.validate(_formFields);
                var valid = Array.from(_form.querySelectorAll(".form__group--error"));
                if (valid.length === 0) {
                    _this.count += 1;
                    if (!_this.iSstep1Completed && !dataLayer.formisSubmitted)
                        _this.analyticsService.dtmFormComplete("complete", "", true);
                    _this.iSstep1Completed = true;
                    _this.dtmVirtualPage("step 2 business details form");
                    _this.showStep(2);
                }
            });
        }
        //Step 2 Next Button
        if (this.step2Button) {
            this.step2Button.addEventListener("click", function (pEvent) {
                var _form = _this.form.querySelector(".step2");
                var _formFields = _form.querySelectorAll("input, select");
                _this.validationService.validate(_formFields);
                var valid = Array.from(_form.querySelectorAll(".form__group--error"));
                if (valid.length === 0) {
                    _this.count += 1;
                    if (!_this.iSstep2Completed && !dataLayer.formisSubmitted)
                        _this.analyticsService.dtmFormComplete("complete", "", true);
                    _this.iSstep2Completed = true;
                    _this.dtmVirtualPage("step 3 business financials form");
                    _this.showStep(3);
                }
            });
        }
        //Step 3 Submit Button Click
        if (this.buttonSubmit) {
            this.buttonSubmit.addEventListener("click", function (pEvent) {
                var _form = _this.form.querySelector(".step3");
                var _formFields = _form.querySelectorAll("input, select");
                _this.validationService.validate(_formFields);
                _this.validateSourceOfFunds();
                var valid = Array.from(_form.querySelectorAll(".form__group--error"));
                if (valid.length === 0) {
                    _this.submitForm(_this.form);
                }
            });
        }
        // This adds slashes to the business registration number		
        if (this.businessReg) {
            this.businessReg.addEventListener("input", function (pEvent) {
                if ((pEvent.inputType !== "deleteContentBackward") && (pEvent.inputType !== "deleteContentForward")) {
                    var reg = pEvent.target.value;
                    pEvent.target.value = _this.validationService.formatBusinessReg(reg);
                }
            });
            this.businessReg.addEventListener("blur", function (pEvent) {
                var reg = pEvent.target.value;
                pEvent.target.value = _this.validationService.formatExpression(reg);
            });
        }
        //Back button
        if (this.backButton.length) {
            this.backButton.map(function (item) {
                return item.addEventListener("click", function (event) {
                    _this.showPreviousStep(event);
                });
            });
        }
        if (this.doneSubmit) {
            this.doneSubmit.addEventListener("click", function (event) {
                return _this.closeForm("done");
            });
        }
        if (this.closeButton) {
            this.closeButton.addEventListener("click", function (event) {
                return _this.closeForm("close");
            });
        }
        this.showLessBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.showLessBtn.setAttribute("hidden", "true");
            _this.showMoreBtn.removeAttribute("hidden");
            _this.dataPrivacyDetailArea.setAttribute("hidden", "true");
        });
        this.showMoreBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.showMoreBtn.setAttribute("hidden", "true");
            _this.showLessBtn.removeAttribute("hidden");
            _this.dataPrivacyDetailArea.removeAttribute("hidden");
        });
        this.dataSharingGroupHideBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.dataSharingGroupTextArea.setAttribute("hidden", "true");
            _this.dataSharingGroupHideBtn.setAttribute("hidden", "true");
            _this.dataSharingGroupShowBtn.removeAttribute("hidden");
        });
        this.dataSharingGroupShowBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.dataSharingGroupTextArea.removeAttribute("hidden");
            _this.dataSharingGroupHideBtn.removeAttribute("hidden");
            _this.dataSharingGroupShowBtn.setAttribute("hidden", "true");
        });
        this.dataSharing3rdPartyHideBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.dataSharing3rdPartyTextArea.setAttribute("hidden", "true");
            _this.dataSharing3rdPartyShowBtn.removeAttribute("hidden");
            _this.dataSharing3rdPartyHideBtn.setAttribute("hidden", "true");
        });
        this.dataSharing3rdPartyShowBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.dataSharing3rdPartyTextArea.removeAttribute("hidden");
            _this.dataSharing3rdPartyHideBtn.removeAttribute("hidden");
            _this.dataSharing3rdPartyShowBtn.setAttribute("hidden", "true");
        });
        this.dataSharingBoardersShowBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.dataSharingBoardersTextArea.removeAttribute("hidden");
            _this.dataSharingBoardersShowBtn.setAttribute("hidden", "true");
            _this.dataSharingBoardersHideBtn.removeAttribute("hidden");
        });
        this.dataSharingBoardersHideBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.dataSharingBoardersTextArea.setAttribute("hidden", "true");
            _this.dataSharingBoardersHideBtn.setAttribute("hidden", "true");
            _this.dataSharingBoardersShowBtn.removeAttribute("hidden");
        });
        this.dataSharingTeleSaleShowBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.dataSharingTeleSaleTextArea.removeAttribute("hidden");
            _this.dataSharingTeleSaleShowBtn.setAttribute("hidden", "true");
            _this.dataSharingTeleSaleHideBtn.removeAttribute("hidden");
        });
        this.dataSharingTeleSaleHideBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.dataSharingTeleSaleTextArea.setAttribute("hidden", "true");
            _this.dataSharingTeleSaleHideBtn.setAttribute("hidden", "true");
            _this.dataSharingTeleSaleShowBtn.removeAttribute("hidden");
        });
        this.dataSharingSmsShowBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.dataSharingSmsTextArea.removeAttribute("hidden");
            _this.dataSharingSmsShowBtn.setAttribute("hidden", "true");
            _this.dataSharingSmsHideBtn.removeAttribute("hidden");
        });
        this.dataSharingSmsHideBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.dataSharingSmsTextArea.setAttribute("hidden", "true");
            _this.dataSharingSmsHideBtn.setAttribute("hidden", "true");
            _this.dataSharingSmsShowBtn.removeAttribute("hidden");
        });
        this.dataSharingEmailShowBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.dataSharingEmailTextArea.removeAttribute("hidden");
            _this.dataSharingEmailShowBtn.setAttribute("hidden", "true");
            _this.dataSharingEmailHideBtn.removeAttribute("hidden");
        });
        this.dataSharingEmailHideBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.dataSharingEmailTextArea.setAttribute("hidden", "true");
            _this.dataSharingEmailHideBtn.setAttribute("hidden", "true");
            _this.dataSharingEmailShowBtn.removeAttribute("hidden");
        });
    };
    FormItemBusinessCreditGarageCards.prototype.generateGuid = function () {
        return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
            var r = (Math.random() * 16) | 0;
            var v = c === "x" ? r : (r & 0x3) | 0x8;
            return v.toString(16);
        });
    };
    FormItemBusinessCreditGarageCards.prototype.closeForm = function (type) {
        this.form.reset();
        if (type === "close") {
            this.analyticsService.dtmFormAbandon();
            window.location.href = this.closeButton.getAttribute('data-url');
        }
        else if (type === "done") {
            window.location.href = this.doneSubmit.getAttribute('data-url');
        }
        else {
            // this.analyticsService.dtmFormComplete(`complete`, `true`);
            // this.analyticsService.completeDtmApplication();
        }
    };
    FormItemBusinessCreditGarageCards.prototype.showStep = function (stepId) {
        var showStep = parseFloat(stepId);
        if (this.bulletContainer) {
            var _bullets = Array.from(this.bulletContainer.querySelectorAll(".form-container-wizard__bullets-container--bullet"));
            _bullets.map(function (pItem) {
                var displayStep = parseFloat(pItem.getAttribute("data-step"));
                if (displayStep <= showStep) {
                    pItem.classList.add("form-container-wizard__bullets-container--bullet--active");
                }
                else {
                    pItem.classList.remove("form-container-wizard__bullets-container--bullet--active");
                }
            });
            var _bulletLines = Array.from(this.bulletContainer.querySelectorAll(".form-item-business-credit-garage-cards__form-container-wizard__bullets-container--bullet--link"));
            _bulletLines.map(function (pItem) {
                var displayStep = parseFloat(pItem.getAttribute("data-step"));
                if (showStep > displayStep) {
                    pItem.classList.add("form-item-business-credit-garage-cards__form-container-wizard__bullets-container--bullet--link--active");
                }
                else {
                    pItem.classList.remove("form-item-business-credit-garage-cards__form-container-wizard__bullets-container--bullet--link--active");
                }
            });
        }
        var _steps = Array.from(this.wizardStepsContainer.querySelectorAll(".form-container-wizard__steps--step"));
        var _heading = "";
        _steps.map(function (pStep) {
            var _step = parseFloat(pStep.getAttribute("data-step"));
            if (_step == showStep) {
                _heading = pStep.getAttribute("data-heading");
                pStep.classList.remove("form-container-wizard__steps--hidden");
            }
            else {
                pStep.classList.add("form-container-wizard__steps--hidden");
            }
        });
        var _h3Heading = this.customHeading.querySelector("h3");
        if (_heading != null) {
            _h3Heading.innerHTML = _heading;
        }
        var _stepno = this.stepNo.querySelector("h6");
        if (_stepno != null) {
            _stepno.innerHTML = "STEP " + showStep + " OF 3";
        }
        window.scrollTo(0, 0);
    };
    FormItemBusinessCreditGarageCards.prototype.showNextStep = function (event) {
        var _target = event.currentTarget;
        var _currentStep = _target.closest("[data-step]");
        var _nextStep = _currentStep.getAttribute("data-step");
        this.showStep(parseFloat(_nextStep));
    };
    FormItemBusinessCreditGarageCards.prototype.showPreviousStep = function (event) {
        this.showDisplayView("");
        var _target = event.currentTarget;
        var _currentStep = _target.closest("[data-step]");
        var _nextStep = _currentStep.getAttribute("data-step");
        this.showStep(parseFloat(_nextStep));
        window.scrollTo(0, 0);
    };
    FormItemBusinessCreditGarageCards.prototype.validateSourceOfFunds = function () {
        var sourceOfFundsGroup = this.sourceOfFunds.closest(".form__group");
        var isValid = true;
        var selected = "";
        for (var i = 0; i < this.sourceOfFunds.options.length; i++) {
            if (this.sourceOfFunds.options[i].selected) {
                selected += this.sourceOfFunds.options[i].value + "";
            }
            if (selected !== "") {
                break;
            }
        }
        if (selected === "") {
            isValid = false;
        }
        if (isValid) {
            sourceOfFundsGroup.classList.remove("form__group--error");
            var _errorDiv = sourceOfFundsGroup.querySelector(".form__group--error_message");
            if (_errorDiv) {
                _errorDiv.remove();
            }
        }
        else {
            sourceOfFundsGroup.classList.add("form__group--error");
            var _errorDiv = document.createElement("div");
            _errorDiv.classList.add("form__group--error_message");
            var _errors = document.createElement("ul");
            var _error = document.createElement("li");
            _error.innerHTML = "This field is required";
            _errors.appendChild(_error);
            _errorDiv.appendChild(_errors);
            sourceOfFundsGroup.appendChild(_errorDiv);
        }
    };
    FormItemBusinessCreditGarageCards.prototype.submitForm = function (form) {
        var _this = this;
        // success screens
        var loader = form.querySelector(".form__loader--container");
        var thankYou = form.querySelector(".form__thankyou--container");
        var success = form.querySelector(".form__success--container");
        var error = form.querySelector(".form__error--container");
        var declined = this.form.querySelector(".form__declined--container");
        var fieldsContainer = form.querySelector(".form__fields--container");
        var unsuccessful = this.element.querySelector(".form__unsuccessful--container");
        var name = Array.from(form.querySelectorAll(".form__success-container__firstname"));
        // variables
        var _email = form.querySelector("input[name=email]");
        var _description = form.querySelector("input[name=description]");
        var _recipient = form.querySelector("input[name=recipient]");
        var _subject = form.querySelector("input[name=subject]");
        var _product = form.querySelector("input[name=product]");
        var _businessAccount = this.form.querySelector("input[name=existing-customer]:checked");
        var _businessAccountHeldWith = this.form.querySelector("select[name=business-account-held-with]");
        var _firstname = this.form.querySelector("input[name=first-name]");
        var _surname = this.form.querySelector("input[name=surname]");
        var _contactNumber = this.form.querySelector("input[name=contact-number]");
        var _alternativeContactNumber = this.form.querySelector("input[name=alt-number]");
        var _emailAddress = this.form.querySelector("input[name=email-address]");
        var _southAfricanId = this.form.querySelector("input[name=identity-number]");
        var _monthlyGrossIncome = this.form.querySelector("input[name=monthly-gross-income]");
        var _monthlyExpenses = this.form.querySelector("input[name=monthly-expenses]");
        var _consent = this.form.querySelector("input[name=popia-consent]");
        var _entityType = this.form.querySelector("select[name=entity-type]");
        var _maritalStatus = this.form.querySelector("select[name=marital-status]");
        var _marriedType = this.form.querySelector("input[name=married-cop]:checked");
        var _marriedConsent = this.form.querySelector("input[name=written-consent]:checked");
        var _businessName = this.form.querySelector("input[name=business-name]");
        var _businessRegNumber = this.form.querySelector("input[name=business-registration]");
        var _financialYearEnd = this.form.querySelector("select[name=financial-year-end]");
        var _requestedCreditLimit = this.form.querySelector("input[name=requested-credit-limit]");
        var _intention = this.form.querySelector("input[name=use-of-funds]");
        var _businessMonthlyIncome = this.form.querySelector("input[name=business-monthly-income]");
        var _businessMonthlyExpenses = this.form.querySelector("input[name=business-monthly-expenses]");
        var _sourceOfFunds = this.form.querySelector("select[name=source-of-funds]");
        if (_marriedConsent) {
            if ((_marriedType.value === "YES") && (_marriedConsent.value === "NO")) {
                this.showFailed(_firstname.value);
                return null;
            }
        }
        var options = "";
        if (_sourceOfFunds) {
            for (var i = 0; i < _sourceOfFunds.options.length; i++) {
                if (_sourceOfFunds.options[i].selected) {
                    if (options === "") {
                        if (_sourceOfFunds.options[i].value !== "") {
                            options += _sourceOfFunds.options[i].value;
                        }
                    }
                    else {
                        if (_sourceOfFunds.options[i].value !== "") {
                            options += "," + _sourceOfFunds.options[i].value;
                        }
                    }
                }
            }
        }
        var _sourceOfFundsValue = this.form.querySelector("input[name=source-funds-value]");
        var _postData = {
            'email': (_email ? _email.value : ""),
            'description': (_description ? _description.value : ""),
            'recipient': (_recipient ? _recipient.value : ""),
            'subject': (_subject ? _subject.value : ""),
            'product': (_product ? _product.value : ""),
            'businessAccount': (_businessAccount ? _businessAccount.value : ""),
            'businessAccountHeldWith': (_businessAccountHeldWith ? (_businessAccount.value === "NO" ? _businessAccountHeldWith.value : "") : ""),
            'firstName': (_firstname ? _firstname.value : ""),
            'surname': (_surname ? _surname.value : ""),
            'contactNumber': (_contactNumber ? _contactNumber.value : ""),
            'alternateContactNumber': (_alternativeContactNumber ? _alternativeContactNumber.value : ""),
            'emailAddress': (_emailAddress ? _emailAddress.value : ""),
            'said': (_southAfricanId ? _southAfricanId.value : ""),
            'monthlyGrossIncome': (_monthlyGrossIncome ? _monthlyGrossIncome.value : ""),
            'monthlyExpenses': (_monthlyExpenses ? _monthlyExpenses.value : ""),
            'personalInformationConsent': (_consent ? (_consent.checked ? "YES" : "NO") : ""),
            'entityType': (_entityType ? _entityType.value : ""),
            'maritalStatus': (_maritalStatus ? _maritalStatus.value : ""),
            'formLocation': this.formLocationService.getLocation(),
            'marriedInCommunityOfProperty': (_marriedType ? _marriedType.value : ""),
            'writtenConsent': (_marriedConsent ? _marriedConsent.value : "NO"),
            'businessName': (_businessName ? _businessName.value : ""),
            'businessRegistration': (_businessRegNumber ? _businessRegNumber.value : ""),
            'financialYearEnd': (_financialYearEnd ? _financialYearEnd.value : ""),
            'requestedCreditLimit': (_requestedCreditLimit ? _requestedCreditLimit.value : ""),
            'useOfFunds': (_intention ? _intention.value : ""),
            'businessMonthlyIncome': (_businessMonthlyIncome ? _businessMonthlyIncome.value : ""),
            'businessMonthlyExpenses': (_businessMonthlyExpenses ? _businessMonthlyExpenses.value : ""),
            'sourceOfFunds': options,
            'sourceOfFundsValue': (_sourceOfFundsValue ? _sourceOfFundsValue.value : ""),
            'dataPrivacyConsent': ((_consent ? (_consent.checked ? "YES" : "NO") : "NO")),
            'dataSharingGroup': this.getDataConsentValue(form, 'data-sharing-group'),
            'dataSharing3rdParty': this.getDataConsentValue(form, 'data-sharing-3rd-party'),
            'dataSharingBoarders': this.getDataConsentValue(form, 'data-sharing-boarders'),
            'dataSharingTelesale': this.getDataConsentValue(form, 'data-sharing-telesale'),
            'dataSharingEmail': this.getDataConsentValue(form, 'data-sharing-email'),
            'dataSharingSms': this.getDataConsentValue(form, 'data-sharing-sms'),
            'dataSharingInApp': 'YES'
        };
        // loader + hide form
        this.displayLoader.classList.add("active");
        fieldsContainer.classList.add("hidden");
        // variables
        var url = this.baseUrl + "/services/CompanyCardsForm.jsp";
        // service
        this.formsService.postForm(url, this.http.serialiseObject(_postData)).then(function (pResponse) {
            _this.displayLoader.classList.remove("active");
            $(window).scrollTop(0);
            window.scroll({ top: 0, behavior: "smooth" });
            if (!pResponse.data) {
                _this.analyticsService.dtmRecordSiteError("noerrorcode|service failure occurred|" + url);
                _this.formThankyou.classList.add("active");
                error.classList.remove("hidden");
                error.classList.add("active");
                success.classList.remove("active");
                success.classList.add("hidden");
                declined.classList.remove("active");
                declined.classList.add("hidden");
            }
            else if (pResponse.data === "invalid") {
                _this.analyticsService.dtmRecordSiteError("noerrorcode|invalid fields|" + url);
                _this.formThankyou.classList.add("active");
                error.classList.remove("hidden");
                error.classList.add("active");
                success.classList.remove("active");
                success.classList.add("hidden");
                declined.classList.remove("active");
                declined.classList.add("hidden");
            }
            else {
                name.map(function (_item) {
                    _item.innerHTML = _firstname.value;
                });
                _this.analyticsService.dtmFormComplete("complete", pResponse.code);
                _this.dtmVirtualPage('thank you');
                _this.formThankyou.classList.add("active");
                success.classList.add("active");
                success.classList.remove("hidden");
                error.classList.remove("active");
                error.classList.add("hidden");
                declined.classList.remove("active");
                declined.classList.add("hidden");
            }
        }).catch(function (pError) {
            // service failed
            _this.analyticsService.dtmRecordSiteError("noerrorcode|service failure occurred|" + url);
            _this.displayLoader.classList.remove("active");
            fieldsContainer.classList.remove("hidden");
            _this.formThankyou.classList.add("active");
            error.classList.remove("hidden");
            error.classList.add("active");
            success.classList.remove("active");
            success.classList.add("hidden");
            declined.classList.remove("active");
            declined.classList.add("hidden");
        });
    };
    FormItemBusinessCreditGarageCards.prototype.showFailed = function (pName) {
        if (pName === void 0) { pName = null; }
        if (this.formFields) {
            this.formFields.classList.add("hidden");
            if (this.formThankyou) {
                this.formThankyou.classList.add("active");
                var _successContainer = this.form.querySelector(".form__success--container");
                _successContainer.classList.remove("active");
                _successContainer.classList.add("hidden");
                var _errorContainer = this.form.querySelector(".form__error--container");
                _errorContainer.classList.remove("active");
                _errorContainer.classList.add("hidden");
                var _failContainer = this.form.querySelector(".form__declined--container");
                _failContainer.classList.add("active");
                _failContainer.classList.remove("hidden");
                if (pName) {
                    var _name = _failContainer.querySelector(".form__success-container__firstname");
                    var _title = _failContainer.querySelector(".form__success-container__title");
                    if (_name) {
                        _name.innerHTML = "Thank you, " + pName;
                        if (_title) {
                            _title.innerHTML = "Unfortunately you can not proceed with this application as you require consent from your spouse.";
                        }
                    }
                }
            }
        }
    };
    FormItemBusinessCreditGarageCards.prototype.getDataConsentValue = function (form, selector) {
        var radioBtn = form.querySelector("input[name=\"" + selector + "\"]:checked");
        if (radioBtn && radioBtn.checked) {
            return radioBtn.value.toUpperCase();
        }
        else {
            return null;
        }
    };
    FormItemBusinessCreditGarageCards.prototype.showDisplayView = function (pDisplay) {
        window.scroll({ top: 0, behavior: "smooth" });
        this.displayLoader.classList.add("hidden");
        this.displayFields.classList.add("hidden");
        //this.displaySuccess.classList.add(`hidden`);
        //this.displayError.classList.add(`hidden`);
        //this.displayDecline.classList.add(`hidden`);
        switch (pDisplay) {
            case "success":
                //this.displaySuccess.classList.remove(`hidden`);
                break;
            case "error":
                //this.displayError.classList.remove(`hidden`);
                break;
            case "loader":
                this.displayLoader.classList.remove("hidden");
                break;
            case "decline":
                //this.displayDecline.classList.remove(`hidden`);
                break;
            default:
                this.displayFields.classList.remove("hidden");
        }
    };
    FormItemBusinessCreditGarageCards.prototype.dtmVirtualPage = function (pPageNameNew) {
        var urlPath = window.location.pathname;
        var urlSegments = urlPath.split('/');
        var extractedKey = urlSegments[urlSegments.length - 1];
        var pageMapping = {
            'business-credit-card-form': 'business:products and services:bank with us:company cards:our cards:business credit success thank you',
            'business-garage-card-form': 'business:products and services:bank with us:business and corporate credit cards:see all cards:business garage card success thank you',
        };
        var taggingValue = pPageNameNew === 'thank you' ?
            pageMapping[extractedKey]
            : "business:products and services:bank-with-us:company-cards:business credit card form:" + pPageNameNew;
        dataLayer.pageName = taggingValue;
        if (typeof _satellite == "object") {
            _satellite.track("globalVirtualPageView");
        }
    };
    FormItemBusinessCreditGarageCards.prototype.updatePageName = function (pageName) {
        dataLayer.pageName =
            "business:products and services:bank-with-us:company-cards:business credit card form:" +
                pageName;
    };
    FormItemBusinessCreditGarageCards.prototype.updateFormName = function () {
        var dataNewFormName = "business:products and services:bank-with-us:company-cards:business credit card form";
        this.analyticsService.dtmFormNameUpdate(dataNewFormName);
        this.analyticsService.dtmAllowFormRefresh();
    };
    FormItemBusinessCreditGarageCards.prototype.toggleModifiers = function (event, selector) {
        if (event === void 0) { event = null; }
        var targetModifier = this.element.querySelector(selector);
        var element = "";
        if (event)
            element = event.target;
        if (targetModifier) {
            if (element.value == "YES") {
                targetModifier.classList.remove("form-item-business-credit-garage-cards__active");
                targetModifier.classList.add("form-item-business-credit-garage-cards__hidden");
                this.businessAccountHeld.classList.remove("form__input--required");
            }
            else {
                targetModifier.classList.remove("form-item-business-credit-garage-cards__hidden");
                targetModifier.classList.add("form-item-business-credit-garage-cards__active");
                this.businessAccountHeld.classList.add("form__input--required");
            }
        }
    };
    FormItemBusinessCreditGarageCards.prototype.updateForms = function (pEvent, pType) {
        if (pEvent === void 0) { pEvent = null; }
        if (pType === void 0) { pType = null; }
        var value = "";
        if (pEvent) {
            value = pEvent.target.value;
        }
        if (pType && pType === "entity") {
            if (value === "Sole Proprietor") {
                this.marriageStatus.classList.remove("form__group--hidden");
                this.businessName.classList.add("form__group--hidden");
                this.businessReg.classList.add("form__group--hidden");
            }
            else {
                this.marriageStatusSelect.value = "";
                this.marriageTypeInputs.forEach(function (element) {
                    element.checked = (element.value === "NO") ? true : false;
                });
                this.marriageStatus.classList.add("form__group--hidden");
                this.marriageType.classList.add("form__group--hidden");
                this.marriageConsent.classList.add("form__group--hidden");
                this.businessName.classList.remove("form__group--hidden");
                this.businessReg.classList.remove("form__group--hidden");
            }
        }
        if (pType && pType === "status") {
            if (value === "Married") {
                this.marriageType.classList.remove("form__group--hidden");
            }
            else {
                this.marriageTypeInputs.forEach(function (element) {
                    element.checked = (element.value === "NO") ? true : false;
                });
                this.marriageType.classList.add("form__group--hidden");
                this.marriageConsent.classList.add("form__group--hidden");
            }
        }
        if (pType && pType === "type") {
            if (value === "YES") {
                this.marriageConsent.classList.remove("form__group--hidden");
            }
            else {
                this.marriageConsent.classList.add("form__group--hidden");
            }
        }
        if ((pType === "" || pType === null) && this.marriageStatus && this.marriageType && this.marriageConsent) {
            this.marriageStatusSelect.value = "";
            this.marriageTypeInputs.forEach(function (element) {
                element.checked = (element.value === "NO") ? true : false;
            });
            this.marriageStatus.classList.add("form__group--hidden");
            this.marriageType.classList.add("form__group--hidden");
            this.marriageConsent.classList.add("form__group--hidden");
        }
        if (this.entityType && (pType === "" || pType === null)) {
            if (this.entityType.value === "Sole Proprietor") {
                this.businessName.classList.add("form__group--hidden");
                this.businessReg.classList.add("form__group--hidden");
            }
            else {
                this.businessName.classList.remove("form__group--hidden");
                this.businessReg.classList.remove("form__group--hidden");
            }
        }
    };
    return FormItemBusinessCreditGarageCards;
}(Base));
export { FormItemBusinessCreditGarageCards };



//////////////////
// WEBPACK FOOTER
// ./components/form-item-business-cards/form-item-business-cards.component.ts
// module id = 1045
// module chunks = 0